// extracted by mini-css-extract-plugin
export default {"container":"ListOfMentors_container__D+xXR","table":"ListOfMentors_table__rsMKm"};